module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAMAAADX9CSSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABFUExURUdwTP///////////////////////////////////////////////////////////////////////////////////////1fUNLcAAAAWdFJOUwBGL5mR+bUETNLbeMcaDILjJKznXWdsZQCEAAAAyElEQVQoz21SWRbEIAhDxa1u3Yb7H3WsaEffm3xhStIIAjRYofxFu0dhYYLzMcgESYbo3ctatf0ObsMuscbkSZuN4Q/KLJ61D1mYYUV+bO34kSxYjhHDgohcB6rQvScKwNAqQQ2aFQHBy1adzFNhTw9XYmXnVTulHQj+9Fe297vFv/Z3f8BGf2D4K84jlX54TCMP5y+6++u752/3RRrQdPN9n/k4mqCPzGNHs808nTzPOteFJn2OxaiFRzvt92Wn/bb3gH6f38MX3XcQdXhZpgkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/people.png
// module id = 4BBq
// module chunks = 0